<template>
    <div class="media-grid-container" v-if="media.length">
        <div class="columns is-gapless is-mobile mb-3">
            <div class="column is-narrow">
                <i class="fal fa-images fa-fw is-size-4 mr-3"></i>
            </div>
            <div class="column">
                <h4>Trip Photos</h4>
            </div>
            <div class="column is-narrow">
                <!-- Zips every visible original, not just the newest the
                     rail happens to show. -->
                <a class="download-all is-size-7" :href="downloadAllUrl">
                    <i class="fas fa-download mr-1"></i>Download all
                </a>
            </div>
        </div>

        <div class="media-grid">
            <div class="media-cell" v-for="photo in media" :key="photo.id" @click="lightbox = photo">
                <template v-if="isVideo(photo)">
                    <video preload="metadata" muted playsinline :src="videoUrl(photo)"></video>
                    <span class="play-badge"><i class="fas fa-play"></i></span>
                </template>
                <img v-else :src="photoUrl(photo, 'thumb')"/>
            </div>
        </div>

        <b-modal v-model="lightboxOpen">
            <div v-if="lightbox">
                <p class="image" v-if="isVideo(lightbox)">
                    <video controls autoplay playsinline :src="videoUrl(lightbox)" class="lightbox-video"></video>
                </p>
                <p class="image" v-else>
                    <img :src="photoUrl(lightbox, 'feed')"/>
                </p>
                <div class="lightbox-footer">
                    <p class="lightbox-caption" v-if="lightbox.caption">{{ lightbox.caption }}</p>
                    <a class="lightbox-download" :href="downloadUrl(lightbox)">
                        <i class="fas fa-download mr-2"></i>Download
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {url} from '@/http_client';

    export default {
        name: 'MediaGrid',
        props: {
            media: {type: Array, required: true},
            regId: {type: Number, required: true}
        },
        data: function() {
            return {
                apiUrl: url,
                lightbox: null
            };
        },
        computed: {
            ...mapGetters(['token']),
            lightboxOpen: {
                get: function() { return !!this.lightbox; },
                set: function(v) { if (!v) this.lightbox = null; }
            },
            downloadAllUrl: function() {
                return `${this.apiUrl}app/experience/${this.regId}/media/download?auth=${this.token}`;
            }
        },
        methods: {
            photoUrl: function(photo, size) {
                return `${this.apiUrl}app/experience/${this.regId}/photo/${photo.file}/${size}?auth=${this.token}`;
            },
            isVideo: function(photo) {
                return !!photo.file_mime && photo.file_mime.indexOf('video/') === 0;
            },
            // #t=0.001 nudges the browser to render the first frame as the
            // preview — videos have no server-generated poster (no ffmpeg).
            videoUrl: function(photo) {
                return this.photoUrl(photo, 'feed') + '#t=0.001';
            },
            // Server answers with Content-Disposition: attachment (original
            // file, uploader's filename), so a plain href saves instead of
            // navigating.
            downloadUrl: function(photo) {
                return `${this.apiUrl}app/experience/${this.regId}/photo/${photo.file}?download&auth=${this.token}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .media-grid-container {
        .download-all {
            color: #7a7a7a;

            &:hover {
                color: #628b21;
            }
        }

        .lightbox-video {
            width: 100%;
            max-height: 80vh;
            display: block;
            background-color: black;
        }

        .lightbox-footer {
            background-color: rgba(0, 0, 0, 0.7);
            padding: 0.6rem 1rem;
            display: flex;
            align-items: flex-start;
            gap: 1rem;

            .lightbox-caption {
                flex: 1;
                color: white;
                font-size: 0.95rem;
                white-space: pre-wrap;
                word-break: break-word;
            }

            .lightbox-download {
                margin-left: auto;
                white-space: nowrap;
                color: white;
                font-size: 0.9rem;

                &:hover {
                    color: #dbdbdb;
                }
            }
        }

        .media-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.3rem;

            .media-cell {
                cursor: pointer;
                border-radius: 0.3rem;
                overflow: hidden;
                aspect-ratio: 1;
                background-color: #f0f0f0;
                position: relative;

                img,
                video {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                .play-badge {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                    background-color: rgba(0, 0, 0, 0.55);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.7rem;
                    pointer-events: none;
                }
            }
        }
    }
</style>
